<template>
  <div>
    <div id="target-side-menu" class="menu h-100">
      <div class="menu__header d-flex d-md-none">
        <div
          class="navbar__item navbar__menu d-flex flex-column justify-content-center align-items-center"
          @click="toggleHiddenMobileMenu()"
        >
          <img class="navbar__menu__close" src="@/assets/icons/menu/ico-close.svg" />
          <div class="text-uppercase w-100">menu</div>
        </div>
        <ProjectChanger v-if="!menuMobileHidden" class="w-100" />
      </div>
      <!--
        Every link below needs :customerId/:projectId. An empty param is not treated as
        absent — RouterLink throws "Missing required param" while resolving — and the admin
        layout renders this menu unconditionally, so guard the whole section.
      -->
      <div v-if="customerId && projectId" class="menu__section">
        <RouterLink
          :to="{
            name: 'dashboard',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          class="menu__item__wrapper text-decoration-none"
          data-testid="mainmenu-dashboard"
          @click="closeMenu"
        >
          <div class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-dashboard-white.svg" />
              </div>
              {{ $t("dashboard") }}
            </div>
          </div>
        </RouterLink>
        <RouterLink
          :class="'menu__item__wrapper text-decoration-none ' + (currentModule == 'group' ? ' active' : '')"
          :to="{
            name: 'groups',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          data-testid="mainmenu-groups"
          @click="closeMenu"
        >
          <div class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-routing-group-white.svg" />
              </div>
              {{ $t("routovaciSkupiny") }}
            </div>
          </div>
        </RouterLink>
        <div id="hasSubmenu" ref="hasSubmenu" class="menu__item__wrapper menu__item__wrapper--hasSubmenu">
          <RouterLink
            :class="
              'menu__item__wrapper text-decoration-none ' +
              (currentModule === 'device' || currentModule === 'mqttDevices' ? ' active' : '')
            "
            :to="{
              name: 'devices',
              params: {
                customerId: customerId,
                projectId: projectId
              }
            }"
            data-testid="mainmenu-devices"
            @click="openActiveSubmenu"
          >
            <div class="menu__item">
              <div class="menu__item__inner">
                <div class="icon">
                  <img src="@/assets/icons/menu/ico-menu-zarizeni-white.svg" />
                </div>
                {{ $t("zarizeni") }}
              </div>
            </div>
          </RouterLink>
          <div
            :class="'menu__submenu' + (currentModule === 'device' || currentModule === 'mqttDevices' ? ' opened' : '')"
          >
            <RouterLink
              :class="'menu__submenu__item menu__submenu__item--lora' + (currentModule === 'device' ? ' active' : '')"
              :to="{
                name: 'lora',
                params: {
                  customerId: customerId,
                  projectId: projectId
                }
              }"
              data-testid="mainmenu-devices-lora"
              @click="closeMenu"
            >
              {{ $t("LORA_ZARIZENI") }}
            </RouterLink>
            <RouterLink
              :class="
                'menu__submenu__item menu__submenu__item--mqtt' +
                (currentModule === 'mqttDevice' || currentModule === 'mqttDevices' ? ' active' : '')
              "
              :to="{
                name: 'mqttDevices',
                params: {
                  customerId: customerId,
                  projectId: projectId
                }
              }"
              data-testid="mainmenu-devices-mqtt"
              @click="closeMenu"
            >
              {{ $t("MQTT_ZARIZENI") }}
            </RouterLink>
            <!--            <RouterLink-->
            <!--              :class="-->
            <!--                'menu__submenu__item menu__submenu__item&#45;&#45;mqtt' +-->
            <!--                (currentModule === 'httpDevices' || currentModule === 'httpDevices' ? ' active' : '')-->
            <!--              "-->
            <!--              :to="{-->
            <!--                name: 'httpDevices',-->
            <!--                params: {-->
            <!--                  customerId: customerId,-->
            <!--                  projectId: projectId-->
            <!--                }-->
            <!--              }"-->
            <!--              @click="closeMenu"-->
            <!--            >-->
            <!--              {{ $t("HTTP_ZARIZENI") }}-->
            <!--            </RouterLink>-->
            <RouterLink
              :class="
                'menu__submenu__item menu__submenu__item--mqtt' +
                (currentModule === 'udpDevices' || currentModule === 'udpDevice' ? ' active' : '')
              "
              :to="{
                name: 'udpDevices',
                params: {
                  customerId: customerId,
                  projectId: projectId
                }
              }"
              data-testid="mainmenu-devices-udp"
              @click="closeMenu"
            >
              {{ $t("UDP_ZARIZENI") }}
            </RouterLink>
          </div>
        </div>
        <div id="hasSubmenu" ref="hasSubmenu" class="menu__item__wrapper menu__item__wrapper--hasSubmenu">
          <RouterLink
            :class="'menu__item__wrapper text-decoration-none ' + (currentModule === 'endpoint' ? ' active ' : '')"
            :to="{
              name: 'endpoints',
              params: {
                customerId: customerId,
                projectId: projectId
              }
            }"
            data-testid="mainmenu-endpoints"
            @click="openActiveSubmenu"
          >
            <div class="menu__item">
              <div class="menu__item__inner">
                <div class="icon">
                  <img src="@/assets/icons/menu/ico-menu-endpointy-white.svg" />
                </div>
                {{ $t("MENU_VYSTUPY") }}
              </div>
            </div>
          </RouterLink>
          <div
            :class="
              'menu__submenu' + (currentModule === 'endpoints' || currentModule === 'mqttEndpoints' ? ' opened' : '')
            "
          >
            <RouterLink
              :class="
                'menu__submenu__item menu__submenu__item--lora' +
                (currentModule === 'endpoints' || currentModule === 'endpoint' ? ' active' : '')
              "
              :to="{
                name: 'endpoints',
                params: {
                  customerId: customerId,
                  projectId: projectId
                }
              }"
              data-testid="mainmenu-endpoints-http"
              @click="closeMenu"
            >
              {{ $t("endpointy") }}
            </RouterLink>
            <RouterLink
              :class="
                'menu__submenu__item menu__submenu__item--mqtt' +
                (currentModule === 'mqttEndpoint' || currentModule === 'mqttEndpoints' ? ' active' : '')
              "
              :to="{
                name: 'mqttEndpoints',
                params: {
                  customerId: customerId,
                  projectId: projectId
                }
              }"
              data-testid="mainmenu-endpoints-mqtt"
              @click="closeMenu"
            >
              {{ $t("MQTT_BRANY") }}
            </RouterLink>
          </div>
        </div>
        <div class="menu__item menu__item--small" />
      </div>
      <div v-if="customerId && projectId" class="menu__section">
        <RouterLink
          :class="'menu__item__wrapper text-decoration-none ' + (currentModule === 'simcards' ? ' active' : '')"
          :to="{
            name: 'simcards',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          data-testid="mainmenu-simcards"
          @click="closeMenu"
        >
          <div class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-simcard.svg" />
              </div>
              {{ $t("MENU_SIMCARDS") }}
            </div>
          </div>
        </RouterLink>
        <RouterLink
          v-if="authStore.apiUser && authStore.apiUser.isIotAdmin"
          :class="
            'menu__item__wrapper text-decoration-none ' +
            (currentModule === 'transformation-functions' ? ' active' : '')
          "
          :to="{
            name: 'transformationFunctions',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          data-testid="mainmenu-transformations"
          @click="closeMenu"
        >
          <div class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-transformation-functions.svg" />
              </div>
              {{ $t("MENU_TRANSFORMATION_FUNCTIONS") }}
            </div>
          </div>
        </RouterLink>
        <RouterLink
          v-if="authStore.apiUser && authStore.apiUser.isIotAdmin"
          :class="'menu__item__wrapper text-decoration-none ' + (currentModule === 'hw-catalogue' ? ' active' : '')"
          :to="{
            name: 'hwCatalogue',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          data-testid="mainmenu-hw-catalogue"
          @click="closeMenu"
        >
          <div class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-hw-catalogue.svg" />
              </div>
              {{ $t("MENU_HW_CATALOGUE") }}
            </div>
          </div>
        </RouterLink>
        <RouterLink
          :to="{
            name: 'admin',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          class="menu__item__wrapper text-decoration-none"
          data-testid="mainmenu-admin"
          @click="closeMenu"
        >
          <div id="target-admin-menu" class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-spravce-white.svg" />
              </div>
              {{ $t("menuSpravce") }}
            </div>
          </div>
        </RouterLink>
        <!--router-link tag="div" to="/downlink-messages" class="menu__item__wrapper">
          <div class="menu__item">
            <div class="menu__item__inner"><div class="icon"><img src="@/assets/icons/menu/ico-menu-downlink-white.svg"></div>{{ $t("frontaDownlinkZprav") }}</div>
          </div>
        </router-link-->
        <RouterLink
          :to="{
            name: 'signal-checker',
            params: {
              customerId: customerId,
              projectId: projectId
            }
          }"
          class="menu__item__wrapper text-decoration-none"
          data-testid="mainmenu-signal-checker"
          @click="closeMenu"
        >
          <div class="menu__item">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-signal-checker.svg" />
              </div>
              {{ $t("pokrytiLoRaSignalem") }}
            </div>
          </div>
        </RouterLink>
        <div class="menu__item menu__item--small" />
      </div>
      <div class="menu__section d-none d-md-block">
        <div class="menu__item__wrapper">
          <div class="menu__item font-weight-light" @click="toggleHiddenMenu()" data-testid="mainmenu-hide">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-menu-skryvat-white.svg" />
              </div>
              {{ $t("skryvatMenu") }}
            </div>
          </div>
        </div>
      </div>
      <RouterLink
        v-if="authStore.apiUser && authStore.apiUser.isIotAdmin"
        :to="{
          name: 'about'
        }"
        class="menu__item__wrapper text-decoration-none"
        data-testid="mainmenu-about"
        @click="closeMenu"
      >
        <div class="menu__item__wrapper">
          <div class="menu__item font-weight-light">
            <div class="menu__item__inner">
              <div class="icon">
                <img src="@/assets/icons/menu/ico-help.svg" />
              </div>
              About
            </div>
          </div>
        </div>
      </RouterLink>
    </div>
  </div>
</template>
<script>
import $ from "jquery"
import ProjectChanger from "@/components/project-changer/project-changer"
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"

export default {
  components: {
    ProjectChanger
  },
  props: {},
  setup() {
    const authStore = useAuthStore()
    const customerStore = useCustomerStore()
    const projectStore = useProjectStore()
    const configStore = useConfigStore()

    return { authStore, customerStore, projectStore, configStore }
  },
  data() {
    return {
      showMqttDevicesItem: localStorage.getItem("showMqttDeviceMenuItem") > 0,
      showMqttGatesItem: localStorage.getItem("showMqttGateMenuItem") > 0,
      projectsVisible: false,
      userMenuVisible: false,
      currentModule: this.$router.currentRoute.value.name,
      projectId: this.$router.currentRoute.value.params.projectId
        ? this.$router.currentRoute.value.params.projectId
        : localStorage.getItem("selectedProject") && localStorage.getItem("selectedProject") != "null"
        ? JSON.parse(localStorage.getItem("selectedProject")).projectId
        : "",
      customerId: this.$router.currentRoute.value.params.customerId
        ? this.$router.currentRoute.value.params.customerId
        : localStorage.getItem("selectedCustomer") && localStorage.getItem("selectedCustomer") != "null"
        ? JSON.parse(localStorage.getItem("selectedCustomer")).customerId
        : ""
    }
  },
  computed: {
    menuHidden() {
      return this.$store.getters["menu/ifHideMenu"]
    },
    menuMobileHidden() {
      return this.$store.getters["menu/ifHideMobileMenu"]
    },
    storedCustomer() {
      return this.customerStore.selectedCustomer
    },
    storedProject() {
      return this.projectStore.selectedProject
    },
    isMqttDeviceItem() {
      return this.configStore.shouldShowMqttDeviceMenuItem
    },
    isMqttGateItem() {
      return this.configStore.shouldShowMqttGateMenuItem
    }
  },
  watch: {
    $route() {},
    // watch for customer change
    storedCustomer(newVal) {
      if (newVal?.customerId) {
        this.customerId = newVal.customerId
      }
    },
    // watch for project change
    storedProject(newVal) {
      if (newVal?.projectId) {
        this.projectId = newVal.projectId
      }
    },
    isMqttDeviceItem() {
      this.showMqttDevicesItem = this.isMqttDeviceItem
    },
    isMqttGateItem() {
      this.showMqttGatesItem = this.isMqttGateItem
    }
  },
  mounted() {
    $(document).on("click", "#hasSubmenu .menu__item", this.openCloseMenu)
    this.openActiveSubmenu()
  },
  unmounted() {},
  methods: {
    toggleHiddenMenu() {
      if (this.menuHidden) {
        this.$store.commit(
          "menu/setHiddenMenu",
          {
            value: false
          },
          { root: true }
        )
        localStorage.setItem("IsMenuHidden", false)
      } else {
        this.$store.commit(
          "menu/setHiddenMenu",
          {
            value: true
          },
          { root: true }
        )
        localStorage.setItem("IsMenuHidden", true)
      }
    },
    closeMenu() {
      if (!this.menuMobileHidden) {
        this.$store.commit(
          "menu/setHiddenMobileMenu",
          {
            value: true
          },
          { root: true }
        )
      }
    },
    toggleHiddenMobileMenu() {
      if (this.menuMobileHidden) {
        this.$store.commit(
          "menu/setHiddenMobileMenu",
          {
            value: false
          },
          { root: true }
        )
      } else {
        this.$store.commit(
          "menu/setHiddenMobileMenu",
          {
            value: true
          },
          { root: true }
        )
      }
    },
    openCloseMenu(e) {
      let target = $(e.currentTarget)
      if (!this.menuHidden || (this.menuHidden && $(window).width() <= 1024)) {
        if (target.siblings(".menu__submenu").hasClass("opened")) {
          target.siblings(".menu__submenu").removeClass("opened")
          target.parent(".menu__item__wrapper").removeClass("active")
        } else {
          target.siblings(".menu__submenu").addClass("opened")
          target.parent(".menu__item__wrapper").addClass("active")
        }
      }
    },
    openActiveSubmenu() {
      var activeMenu = $("#hasSubmenu .menu__submenu__item.active")
      activeMenu.parent().addClass("opened")
      activeMenu.parent().parent().addClass("active")
    },
    showDropdown(menu) {
      this[menu] ? (this[menu] = false) : (this[menu] = true)
    },
    openNewEndpoint() {
      this.$store.commit("modals/setNewEndpointVisible", {
        showNewEndpoint: true
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
